'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                              * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                              * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                              */
// 文案组件

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$label = props.label,
        label = _props$label === undefined ? '' : _props$label;

    var result = null;

    if ((typeof label === 'undefined' ? 'undefined' : _typeof(label)) === 'object') {
        result = _react2.default.createElement(
            'span',
            { className: 'spaui-rating-text' },
            label
        );
    } else {
        result = _react2.default.createElement('span', { className: 'spaui-rating-text', dangerouslySetInnerHTML: { __html: label } });
    }

    return result;
};